<template>
  <div
    class="flex flex-col items-center justify-center h-screen relative"
    style="z-index: 0"
  >
     <div class="background-image absolute top-0 left-0 w-full h-full">
      <!-- SVG backgrounds copied from login-form.vue -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="absolute top-0 left-0"
        width="25%"
        height="80%"
        viewBox="0 0 364 663"
        fill="none"
      >
        <path
          opacity="0.25"
          :style="[
            requestedOrganization &&
            requestedOrganization.theme &&
            requestedOrganization.theme.primary_color
              ? { color: requestedOrganization.theme.primary_color }
              : { color: '#3AF080' },
          ]"
          d="M267.362 -79.865C440.933 58.1153 418.589 276.134 -125 662.037L-112.459 588.786C80.3826 483.411 543.488 156.388 267.362 -79.865Z"
          fill="#3AF080"
        />
      </svg>
      <svg
        width="25%"
        class="absolute top-0 left-0"
        height="80%"
        viewBox="0 0 359 712"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.25"
          :style="[
            requestedOrganization &&
            requestedOrganization.theme &&
            requestedOrganization.theme.primary_color
              ? { color: requestedOrganization.theme.primary_color }
              : { color: '#3AB373' },
          ]"
          d="M242.205 -54.4781C433.553 54.178 412.512 284.485 -3.71298 711.066L-49.466 657.06C128.403 528.009 546.143 144.727 242.205 -54.4781Z"
          fill="#3AB574"
        />
      </svg>
      <div
        class="absolute top-0 right-0 flex items-start justify-end h-full w-full pointer-events-none"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25%"
          class="absolute bottom-0 right-0"
          height="80%"
          viewBox="0 0 393 730"
          fill="none"
          preserveAspectRatio="none"
        >
          <path
            opacity="0.25"
            :style="[
              requestedOrganization &&
              requestedOrganization.theme &&
              requestedOrganization.theme.primary_color
                ? { color: requestedOrganization.theme.primary_color }
                : { color: '#3AF080' },
            ]"
            d="M124.182 792.144C-87.2325 652.363 -75.4235 422.517 533.234 0.413395L504.784 274C300.609 271.371 -191.118 542.494 124.182 792.144Z"
            fill="#3AF080"
          />
        </svg>
        <svg
          width="25%"
          class="absolute bottom-0 right-0"
          height="80%"
          viewBox="0 0 351 852"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.25"
            :style="[
              requestedOrganization &&
              requestedOrganization.theme &&
              requestedOrganization.theme.primary_color
                ? { color: requestedOrganization.theme.primary_color }
                : { color: '#3AB373' },
            ]"
            d="M133.691 902C-70.1671 781.302 -85.6564 533.98 408 0V84.0574C227.292 238.342 -193.581 691.318 133.691 902Z"
            fill="#3AB574"
          />
        </svg>
      </div>
    </div>
     <div class="flex flex-col items-center justify-center z-10 gap-4">
        <div v-if="!requestedOrganization">
            <Logo type="ICON_DARK" class="login-logo" />
        </div>
        <div v-else>
            <img
            :src="requestedOrganization.logo_url"
            alt="Coach Catalyst"
            class="login-logo"
            />
        </div>
        <div
            class="w-4 h-0.5 flex-shrink-0 my-4 self-center"
            :style="[
            requestedOrganization &&
            requestedOrganization.theme &&
            requestedOrganization.theme.primary_color
                ? { background: requestedOrganization.theme.primary_color }
                : { background: '#3AB373' },
            ]"
        >
        </div>
        <h2 class="login-p">Change your password</h2>
        <form
            class="simple_form new_user w-full gap-4"
            id="new_user"
            @submit.prevent="submitForm"
            novalidate
            >
        <div v-if="error" class="text-red-500 mb-2">{{ error }}</div>
        <input
            type="hidden"
            v-model="resetPasswordToken"
            name="reset_password_token"
        />
        <div class="form-inputs flex flex-col gap-4">
            <label for="password" class="font-medium">New password</label>
            <input
            id="password"
            type="password"
            v-model="password"
            required
            autofocus
            class="input"
            placeholder="New password"
            />

            <label for="password_confirmation" class="font-medium">Confirm your new password</label>
            <input
            id="password_confirmation"
            type="password"
            v-model="passwordConfirmation"
            required
            class="input"
            placeholder="Confirm your new password"
            />
        </div>
        <div class="form-actions mt-4">
            <button type="submit" class="btn button submit-button">
            Change my password
            </button>
        </div>
        </form>
        <div class="w-4 h-0.5 flex-shrink-0 my-4 self-center bg-gray-500"></div>
            <div class="self-stretch h-5 text-center justify-start">
              <div class="flex text-center items-center justify-center">
                  <a href="/auth/sign_in">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                    </svg>
                  </a>

                  <span class="text-base font-normal font-['Inter'] mr-2">Back to </span>
                  <a href="/auth/sign_in" class="text-base font-semibold font-['Inter'] cursor-pointer" :style="[
                    requestedOrganization &&
                    requestedOrganization.theme &&
                    requestedOrganization.theme.primary_color
                      ? { color: requestedOrganization.theme.primary_color }
                      : { color: '#3AB373' },
                  ]">Sign in</a>

              </div>
        </div>
       
    </div>
  </div>
</template>

<script>
import ApiUrls from '../api-url';
import AuthenticationMixin from '../authentication-mixin';
import { mapGetters, mapState } from 'vuex';
import Logo from '../components/logos/Logo.vue';

export default {
  mixins: [ApiUrls, AuthenticationMixin],
  components: {
    Logo,
  },
  data() {
    return {
      resetPasswordToken: '', // Set this from query params or props
      password: '',
      passwordConfirmation: '',
    };
  },
  created() {
    // Example: get token from query string
    this.resetPasswordToken = this.$route.query.reset_password_token || '';
    document.title = 'Change Password | Coach Catalyst';

    this.getRequestedOrganization();
  },
  computed: {
    ...mapState(['requestedOrganization']),
    ...mapGetters([]),
  },
  methods: {
    async submitForm() {
      const formData = new FormData();
      formData.append('utf8', '✓');
      formData.append('_method', 'put');
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      formData.append('authenticity_token', csrfToken);
      formData.append('user[reset_password_token]', this.resetPasswordToken);
      formData.append('user[password]', this.password);
      formData.append('user[password_confirmation]', this.passwordConfirmation);
      formData.append('commit', 'Change my password');

      if (!this.password || !this.passwordConfirmation) {
        this.$toast.show('Please fill in all fields.', this.toasted_options.error );
        return;
      }
      if (this.password !== this.passwordConfirmation) {
        this.$toast.show('Passwords do not match.', this.toasted_options.error );
        return;
      }
      try {
        const response = await this.axiosInstance.post('/auth/password', formData, {
          headers: { 'X-CSRF-Token': csrfToken }
        });
        if (response.status === 200) {
          this.$toast.show('Password changed successfully.', this.toasted_options.success );
          window.location.href = '/';
         
        } else {
          this.$toast.show('Password change failed.', this.toasted_options.error );
        }
      } catch (err) {
        this.$toast.show(
          err?.response?.data?.error || 'Failed to change password.',
          this.toasted_options.error
        );
      }
    },

    async getRequestedOrganization() {
      const org_subdomain = window.location.host.split('.')[0];
      const { data } = await this.axiosInstance.post(`${this.organizationUrl}requested_organization`, { org_subdomain });
      if (data.success) {
        await this.$store.commit('setRequestedOrganization', data.result);
      }
    },
  },
};
</script>

<style lang="scss"></style>